import { createSearchServiceClient } from "~/api/apiClient";
import type { components } from "~/api/generated/search-service-types";

export type SearchAuditReference =
  components["schemas"]["SearchAuditReference"];

/** Travels with a result through caching, sorting, and hydration. */
export interface SearchSelectionMetadata {
  searchAudit?: SearchAuditReference | null;
}

/** Best-effort telemetry; callers can navigate immediately. The API client reports failures. */
export async function recordSearchSelection(
  audit: SearchAuditReference | null | undefined,
  selectedResultId: string,
): Promise<void> {
  // Legacy AppSync results and older search-service deployments have no reference.
  if (!audit) return;
  try {
    await createSearchServiceClient().POST("/search/selections", {
      body: { audit, selected_result_id: selectedResultId },
      keepalive: true,
    });
  } catch {
    // Never interrupt selection or create an unhandled rejection on network failure.
  }
}
